import axios from 'axios';
import { URL_API, URL_PAGE } from '../constants/urls';

const httpInstance = axios.create( {
    baseURL: URL_API 
});


httpInstance.interceptors.response.use(null, error => {
    //console.log(error)
    //console.log(error.response)
    if(error.response === undefined){
        alert("Hola estamos teniendo problemas de conexión con el servidor intente más tarde.")
    }else if(error.response.status===403){
        window.sessionStorage.setItem('authIke', null);
       window.location.href=URL_PAGE
       return;
    }else{
        return Promise.reject(error);    
    }    
});

export default httpInstance;
